import { getJSON } from './ultile';
import globalConfig from '../utiles/globalConfig';

const MAIN_HOST = globalConfig.getMainHost();
export const CHECK_IP_LOCATION = 'checkIpLocation';
const CHANGE_LOCATION = 'changeLocation';
const LOCATION_STORE_KAY = 'locationDetectByIP';
const LOCATION_TIME_KEY = 'locationStoreTimeKey';

// IP信息在内存缓存一天

/*
@parameter value
*/
let storeLocation = function (value) {
  let time = new Date().getTime();
  localStorage.setItem(LOCATION_TIME_KEY, time);
  try {
    localStorage.setItem(LOCATION_STORE_KAY, JSON.stringify(value));
  } catch (e) {}
};

let getStoreLocationStatus = function () {
  let storeTime = localStorage.getItem(LOCATION_TIME_KEY);
  let now = new Date().getTime();
  return now - storeTime < 86400000;
};

let getLocationInfoStored = function () {
  let storeVal = localStorage.getItem(LOCATION_STORE_KAY);
  let res = {
    ISO_TWO_CODE: ''
  };
  try {
    res = storeVal && JSON.parse(storeVal);
  } catch (e) {}
  return res;
};

// hex解码
const hexToString = str => {
  try {
    str = window.atob(str);
  } catch (_e) {
    return '';
  }
  if (str.length % 2) return '';
  try {
    let strArr = [];
    // 因为大小字母均只有两位
    for (let i = 0; i < str.length; i += 2) {
      strArr.push(parseInt(str.slice(i, i + 2), 16));
    }
    return String.fromCharCode(...strArr);
  } catch (_e) {
    return '';
  }
};

export default {
  state: {
    //国家地区代码 ISO两位，比如中国CN 越南 VN
    ISO_TWO_CODE: ''
  },
  mutations: {
    [CHANGE_LOCATION](state, locationInfo) {
      state.ISO_TWO_CODE = locationInfo['ISO_TWO_CODE'];
    }
  },
  actions: {
    [CHECK_IP_LOCATION]({ commit }, gameId) {
      const ACTION = `https://gcollectsecond.octlib.com/Index/GetLcsCode`;
      const storeExistLocationInfo = getStoreLocationStatus();
      const GAME_ID = gameId || globalConfig.getHrefParamUndecode('gameId');
      return new Promise((resolve, reject) => {
        // 是否有24 小时内的缓存
        if (storeExistLocationInfo) {
          let locationInfo = getLocationInfoStored();
          commit(CHANGE_LOCATION, locationInfo);
          resolve(locationInfo);
          return;
        }
        getJSON(ACTION, {
          gameId: GAME_ID
        })
          .then(({ errmsg, data }) => {
            if (errmsg === '') {
              let res = {
                ISO_TWO_CODE: ''
              };
              // 这需要先base64解码、再hex解码

              try {
                let localCode = hexToString(data.code);
                res = {
                  ISO_TWO_CODE: localCode
                };
              } catch (_e) {}
              commit(CHANGE_LOCATION, res);
              storeLocation(res);
              resolve(res);
            } else {
              reject(new Error(errmsg));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
